module.exports = __webpack_public_path__ + "img/photo-68.1fef89e5.webp";